import { apiClient } from './client';
import type { ApiResponse, Credential } from '@/types/api.types';

export const credentialsApi = {
  list: () =>
    apiClient.get<ApiResponse<Credential[]>>('/credentials'),

  get: (id: string) =>
    apiClient.get<ApiResponse<Credential>>(`/credentials/${id}`),

  create: (data: { label: string; apiToken: string; senderId: string; isActive?: boolean }) =>
    apiClient.post<ApiResponse<Credential>>('/credentials', data),

  update: (id: string, data: { label?: string; apiToken?: string; senderId?: string; isActive?: boolean }) =>
    apiClient.patch<ApiResponse<Credential>>(`/credentials/${id}`, data),

  delete: (id: string) =>
    apiClient.delete(`/credentials/${id}`),

  test: (id: string) =>
    apiClient.post<ApiResponse<{ success: boolean; templatesFound?: number; error?: string }>>(
      `/credentials/${id}/test`,
    ),

  registerWebhook: (id: string) =>
    apiClient.post<ApiResponse<{ subscriptionId: string | null; action: string; webhookUrl: string }>>(
      `/credentials/${id}/register-webhook`,
    ),
};
